import { Transition } from "@headlessui/react";
import { useCallback, useState } from "react";
import { adminUserService } from "../../services/admin/admin.customer.service";
import {useDropzone} from 'react-dropzone'

const NewReleaseModal = ({ open, setOpen }) => {
  const [inputs, setInputs] = useState({})
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false)

  const handleChange = (e) => {
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    console.log(inputs);
  }

  const handlePublish = async () => {
    const s3UploadUrl = await adminUserService.createS3UploadUrl(file.path)
    const url = s3UploadUrl.data.url;

    const formData = new FormData();
    formData.append('file', file);

    setUploading(true)
    const result = await fetch(url, {
      method: "PUT",
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      body: file
    });
    setUploading(false)

    if (result.status === 200) {
      await adminUserService.publishRelease(file.path, inputs.updates, inputs.notes);
    }

    setOpen();
  }

  const handleDrop = useCallback(async acceptedFiles => {
    setFile(acceptedFiles[0])
  }, [])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop: handleDrop})


  return (
    <Transition
      show={open}
      enter="transition-opacity duration-500"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-500"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
      <div className="bg-[#000000A0] w-full h-full fixed top-0 left-0 right-0 bottom-0 z-10 "></div>
      <div className="flex justify-center items-center">
        <div className='w-[45vw] bg-[#13181E] border border-[#1B1F25] z-30 rounded-lg mt-24 pb-4' id="fade">
          <div className='flex'>
            <div className='w-full'>
              <p className='text-xl text-white font-semibold ml-4 mt-3'>Upload New Release</p>
            </div>
          </div>

          <div className='ml-4 mr-4'>

            <div className="upload-styles-2">
              <div {...getRootProps()} className='mt-4 h-48 border-dashed border-4 border-gray-800 rounded-lg flex justify-center items-center'>
                <input {...getInputProps()} />
                <p className='text-center text-gray-600 text-sm mt-1'>
                  {file == null ?
                  isDragActive ? 'Release to drop the files here' : 'Drag & drop some files here, or click to select files' : uploading ? 'File uploading...' : `${file.path} selected`}
                </p>
              </div>
            </div>

            <div>
              <label className='relative top-1 text-sm text-gray-500'>Updates (One per line)</label>
              <textarea id="updates" name="updates" onChange={handleChange}
                        className='w-full h-56 mt-2 rounded-lg pl-3 bg-[#1B2127] border border-[#282F37] pt-2 text-white'
                        placeholder='Enter each change on a new line'>
              </textarea>
            </div>

            <div>
              <label className='relative top-1 text-sm text-gray-500'>Additional Notes</label>
              <textarea id="notes" name="notes" onChange={handleChange}
                        className='w-full h-56 mt-2 rounded-lg pl-3 bg-[#1B2127] border border-[#282F37] pt-2 text-white'
                        placeholder='Enter any additional notes or information here'>
              </textarea>
            </div>


            <div className='flex'>
              <button
                onClick={handlePublish}
                className="dark:disabled:bg-red-500 disabled:cursor-not-allowed cursor-pointer px-3 h-8 text-sm rounded-md text-gray-800 dark:text-white bg-white dark:bg-gray-700 hover:bg-white dark:hover:bg-gray-600 border border-gray-300 dark:border-gray-600 after:via-gray-100 dark:after:via-gray-500 focus:outline-none shadow-sm hover:shadow focus:shadow active:shadow-none box-border relative after:absolute inline-flex items-center align-middle min-w-min select-none outline-none justify-center text-center whitespace-nowrap transition appearance-none focus:outline-none font-medium">
                Publish
              </button>

              <button
                onClick={setOpen}
                className="ml-4 bg-red-500 disabled:cursor-not-allowed cursor-pointer px-3 h-8 text-sm rounded-md text-gray-800 dark:text-white bg-white hover:bg-red-600 border border-gray-300 dark:border-gray-600 after:via-gray-100 dark:after:via-gray-500 focus:outline-none shadow-sm hover:shadow focus:shadow active:shadow-none box-border relative after:absolute inline-flex items-center align-middle min-w-min select-none outline-none justify-center text-center whitespace-nowrap transition appearance-none focus:outline-none font-medium">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </Transition>
  )
}

export default NewReleaseModal;